export { BUNDLE_BUILD_TIME, BUNDLE_GIT_COMMIT } from "#bundle-build-time";
